import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import styles from '../styles/ServicesSidebar.module.css';
import { ROUTES } from '../utils/Routes';

const ServicesSidebar = () => {
  const services = [
    { title: 'Business Consultation', path: `${ROUTES.SERVICE_ROUTE}/business-consultation` },
    { title: 'Start-up Funding', path: `${ROUTES.SERVICE_ROUTE}/start-up-funding` },
    { title: 'Community Empowerment', path: `${ROUTES.SERVICE_ROUTE}/community-empowerment` },
    { title: 'ESG/CSR Project Management and Consulting', path: `${ROUTES.SERVICE_ROUTE}/esg-csr-project` }
  ];

  const instagramImages = [
    { src: '/images/Services/insta-1.jpg', alt: 'Instagram post 1' },
    { src: '/images/Services/insta-2.jpg', alt: 'Instagram post 2' },
    { src: '/images/Services/insta-3.jpg', alt: 'Instagram post 3' },
    { src: '/images/Services/insta-4.jpg', alt: 'Instagram post 4' },
    { src: '/images/Services/insta-5.jpg', alt: 'Instagram post 5' },
    { src: '/images/Services/insta-6.jpg', alt: 'Instagram post 6' }
  ];

  return (
    <div className={styles.servicesSidebar}>
      {/* Services List Section */}
      <div className={styles.sidebarSection}>
        <div className={styles.sectionHeader}>
          <h2>All Services</h2>
        </div>
        <div className={styles.servicesList}>
          {services.map((service, index) => (
            <Link to={service.path} key={index} className={styles.sideServiceItem}>
              <span className={styles.sideServiceIcon}><img src="/icons/orangeRightArrow.svg" alt="arrow-right" /></span>
              <span className={styles.serviceTitle}>{service.title}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Newsletter Section */}
      <div className={styles.sidebarSection}>
        <div className={styles.sectionHeader}>
          <h2>Newsletter</h2>
        </div>
        <div className={styles.newsletterContent}>
          <h3>Join 20,000 Subscribers!</h3>
          <Form className={styles.newsletterForm}>
            <Form.Group className="mb-3">
              <Form.Control type="email" placeholder="Email Address" />
            </Form.Group>
            <Button type="submit" className="w-100">Sign Up</Button>
          </Form>
          <p className={styles.privacyText}>
            By signing up you agree to our <Link to="/privacy-policy">Privacy Policy</Link>
          </p>
        </div>
      </div>

      {/* Instagram Gallery Section */}
      {/* <div className={styles.sidebarSection}>
        <div className={styles.sectionHeader}>
          <h2>Instagram Shot</h2>
        </div>
        <Row className="g-2">
          {instagramImages.map((image, index) => (
            <Col xs={4} key={index}>
              <div className={styles.instagramItem}>
                <img src={image.src} alt={image.alt} />
              </div>
            </Col>
          ))}
        </Row>
      </div> */}

      {/* Contact Section */}
      <div className={styles.contactSection}>
        <h2>Curious about how we can help?</h2>
        <p>Let's connect! Reach out today and discover how we can empower your organisation and community together!</p>
        <Link to={ROUTES.CONTACTUS_ROUTE} className={styles.contactButton}>
          Contact Us
          <span className={styles.buttonIcon}>→</span>
        </Link>
      </div>
    </div>
  );
};

export default ServicesSidebar; 